import React from 'react';
import {useKeycloak} from '@react-keycloak/web';

const PrivateRoute = ({children}) => {
    const {keycloak, initialized} = useKeycloak();

    if (!initialized) {
        return <div>Chargement...</div>;
    }

    if (!keycloak.authenticated) {
        keycloak.login();
    }

    return children;
};

export default PrivateRoute;
